import { EngagementFeedsPagedResponse } from '@epicuro-next/data/engagement/engagement-models';
import { createAction, props } from '@ngrx/store';

/** Fetch action */
export const fetch = createAction('[News Feed] Fetch');

/** Fetch success action */
export const fetchSuccess = createAction(
  '[News Feed] Fetch Success',
  props<{ data: EngagementFeedsPagedResponse }>(),
);

/** Fetch fail action */
export const fetchFail = createAction('[News Feed] Fetch Fail');
